import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from '../../Context/ConfigContext'
import axios from 'axios'
import Carousel from 'react-multi-carousel'
import slugify from "slugify";
import { CartsContext } from '../../Context/CartsContext'
import { toast } from 'react-toastify'
import { AddToCartNotifier } from '../../Components/CartComponents'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';

const NewArrivals = () => {

    const { apiURL, apiB2BURL, apiHeaderJson, gdcURL, business_type, currency, setIsCartDropdownOpen } = useContext(ConfigContext)
    const headers = apiHeaderJson;

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [data, setData] = useState([])
    const { AddToCart, GetCartItemQty } = useContext(CartsContext)


    const GetArrivals = async () => {
        try {
            const { data } = await axios.get(
                `${apiB2BURL}/Customer/Dashboard/GetNewArrivals`,
                {
                    params: {
                        currency,
                        type: business_type,
                        lang: "en"
                    }, headers
                }
            )

            if (data?.success) {
                setData(data?.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const responsive = {
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 5 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 3 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 2 }
    }


    const handleAddToCart = async (part) => {
        try {
            // Current cart qty for this product
            const prev_qty = await GetCartItemQty(part.ART_SEARCH_NUMBER);

            // Available stock
            const availableQty = Number(part.VD_QTY || 0);

            // Product image
            const partImg = part.MEDIA_SOURCE
                ? `${gdcURL}/images/${part.MEDIA_SOURCE}`
                : `${apiURL}/public/placeholder_category.jpeg`;

            // Always add 1 item
            if (availableQty <= prev_qty) {
                toast.error(
                    <AddToCartNotifier
                        item_name={t('sorry_we_have_only', { value: availableQty })}
                        item_img={partImg}
                    />
                );
                return;
            }

            const url = window.location.href;

            await AddToCart(part, 1, partImg, url);

            setIsCartDropdownOpen(true);
            window.scrollTo(0, 0);

        } catch (error) {
            console.error("AddToCart Error:", error);
            toast.error(t("something_went_wrong"));
        }
    };


    useEffect(() => {
        GetArrivals()
    }, [])

    return (
        <>
            {
                data?.length > 0 &&
                <div className="container">
                    <div className="mt-3 mb-5">
                        <h4 className="mb-3">New Arrivals</h4>

                        <Carousel
                            responsive={responsive}
                            autoPlaySpeed={2500}
                            infinite
                            pauseOnHover
                            swipeable
                            draggable
                            keyBoardControl
                            removeArrowOnDeviceType={["tablet", "mobile"]}
                        >
                            {data?.map((item, index) => {

                                const OE_part_slug =
                                    slugify(item.PRODUCT_GROUP_EN?.toLowerCase()) +
                                    "-" +
                                    slugify(item.ART_SEARCH_NUMBER?.toLowerCase()) +
                                    "-" +
                                    item?.STR_ID +
                                    "-" +
                                    slugify(String(item.ART_ID));

                                const part_slug =
                                    slugify(item.PRODUCT_GROUP_EN ?? '') +
                                    "-" +
                                    slugify(item.ART_SEARCH_NUMBER ?? '') +
                                    "-" +
                                    item?.STR_ID +
                                    "-" +
                                    slugify(String(item.ART_SUP_ID)) +
                                    "-" +
                                    slugify(String(item.ART_ID));

                                const url =
                                    item?.ART_TYPE === "OENumber"
                                        ? `/OE-Spare-Parts/Details/${OE_part_slug}`
                                        : `/Spare-Parts/Details/${part_slug}`;

                                const partImg = item.MEDIA_SOURCE
                                    ? `${gdcURL}/images/${item.MEDIA_SOURCE}`
                                    : `${apiURL}/public/placeholder_category.jpeg`;

                                return (
                                    <div key={index} style={{ padding: "8px" }}>
                                        <div
                                            className="h-100 d-flex flex-column border rounded shadow-sm"
                                            style={{ cursor: "pointer" }}
                                        >
                                            {/* Image */}
                                            <div
                                                onClick={() => navigate(`${url}`)}
                                                style={{
                                                    height: "180px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: "10px"
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item?.stock_oe === 1 && item?.ART_SEARCH_NUMBER
                                                            ? `https://ghayar.ae/api/GetOEPartMedias?part_number=${item.ART_SEARCH_NUMBER}`
                                                            : partImg || `${apiURL}/public/placeholder_category.jpeg`
                                                    }
                                                    alt={item.ART_ARTICLE_NR}
                                                    onError={(e) => {
                                                        e.currentTarget.src =
                                                            `${apiURL}/public/placeholder_category.jpeg`;
                                                    }}
                                                    style={{
                                                        maxHeight: '100%',
                                                        maxWidth: '100%',
                                                        objectFit: 'contain',
                                                        marginTop: "10px"
                                                    }}
                                                />
                                            </div>

                                            {/* Content */}
                                            <div className="px-2 pb-2 flex-grow-1"
                                                onClick={() => navigate(`${url}`)}
                                            >
                                                <h6 className="mb-1 small text-truncate">
                                                    {item?.PRODUCT_GROUP_EN}
                                                </h6>
                                                <span className="text-muted small">
                                                    Article No: {item?.ART_SEARCH_NUMBER}
                                                </span>
                                            </div>


                                            <div className="px-2 mb-2 mt-2">
                                                <h4>{item?.VD_BB_PRICE} AED</h4>
                                            </div>



                                            {/* Buy Now Button */}
                                            <div className="p-2 mb-1 mt-auto">
                                                <button
                                                    className="btn btn-dark btn-sm w-100"
                                                    onClick={() => handleAddToCart(item)}
                                                ><i className="fas fa-cart-plus mr-2"></i>
                                                    Buy Now
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            )}
                        </Carousel>
                    </div>
                </div>
            }
        </>
    )
}

export default NewArrivals
